import { LOADING } from '../actions/LoadingAction';
export default function (state = { isLoading: false }, action) {
    switch (action.type) {
        case LOADING:
            return { isLoading: action.payload };
        default:
            return state;
    }
}
